import { doGet } from 'hooks/requests';

export const usePaymentsService = () => {
    const getPayments = (data) => {
        const params = new URLSearchParams({
            company_id: data.companyId,
            page: data.page || 1,
            ...(data.sortColumn && { sortColumn: data.sortColumn }),
            ...(data.sortOrder && { sortOrder: data.sortOrder }),
            ...(data.status && { status: data.status }),
            ...(data.startDate && { startDate: data.startDate }),
            ...(data.endDate && { endDate: data.endDate }),
            ...(data.amount && { amount: data.amount }),
            ...(data.type && { type: data.type }),
            ...(data.marketplace && { marketplace: data.marketplace }),
        });
        return doGet(`payment/?${params.toString()}`);
    };

    const getPaymentsSummary = (companyId) => {
        return doGet(`payment/summary/?company_id=${companyId}`);
    };

    return {
        getPayments,
        getPaymentsSummary,
    };
};
